import { z } from 'zod';

export const getPatientSchema = z.object({
  patient_id: z.string().min(1),
});

export type GetPatientPayload = z.infer<typeof getPatientSchema>;
